module.exports = __webpack_public_path__ + "img/owner.70d22b3a.svg";